import { NullValueResolver } from '../null-value-resolver';

/**
 * Represents a null value resolver.
 * 
 * @type {NullValueResolver}
 */
export const NULL_VALUE_RESOLVER: NullValueResolver = () => null;
